const state = require('../../assets/data/mendelable.json')

export default {
  state
}



// WEBPACK FOOTER //
// ./src/store/modules/elements.js